export const environment = {
  production: false,
  apis: {
    identity: '/identity/v1',
    document: '/document/v1',
    property: '/property/v1',
    ads: '/ads/v1'
  }
};
